import React, { useContext } from "react";

import AddBoxIcon from "@mui/icons-material/AddBox";
import Button from "@mui/material/Button";
import ConfirmDialog from "../../General/ConfirmDialog";
import Create from "./Create";
import Edit from "./Edit";
import Entry from "./Entry";
import Grid from "@mui/material/Grid";
import { HomeAppContext } from "../../Home";
import api from "../../../Services/api";
import { errorManagement } from "../../../Services/errorManagement";

import { userStore } from "../../../Services/store";
import MyDataGrid from "../../General/Pagination/MyDataGrid";
import CreateServiceAccount from "./CreateServiceAccount";

const statusValues = [
  { id: "true", text: "Active" },
  { id: "false", text: "Inactive" }
];

export default function List(props) {
  const { homeState, homeDispatch } = useContext(HomeAppContext);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openCreate, setOpenCreate] = React.useState(false);
  const [openCreateService, setOpenCreateService] = React.useState(false);
  const [openReset, setOpenReset] = React.useState(false);
  const [resetParams, setResetParams] = React.useState(false);
  const [currentEntry, setCurrentEntry] = React.useState(null);
  const [refresh, setRefresh] = React.useState(0);

  const isAdmin =
    homeState.userProfile.role === "Admin" ||
    homeState.userProfile.role === "PowerUser";

  const allowActions = isAdmin;

  const handleClickCreate = (event) => {
    setOpenCreate(true);
  };

  const tableOptions = {
    columns: [
      {
        name: "FullName",
        description: "Name",
        sortable: true,
        filter: {
          enabled: false
        },
        size: 50
      },
      {
        name: "RoleId",
        description: "Role",
        sortable: true,
        filter: {
          enabled: false
        },
        size: 50
      },
      {
        name: "Actions",
        description: "",
        sortable: false,
        filter: {
          enabled: false
        },
        size: 10
      }
    ],
    defaultSort: [{ name: "FullName", order: "" }],
    additionalFilters: [
      {
        name: "FullName",
        description: "Name",
        filter: {
          enabled: true,
          name: "NameOrEmailLike",
          comparison: "@=*",
          type: "text",
          value: "",
          defaultIndex: 0,
          placeholder: "Filter name/email"
        },
        size: allowActions ? 4 : "auto"
      },
      {
        name: "RoleId",
        description: "Role",
        filter: {
          enabled: true,
          comparison: "==",
          type: "autocomplete",
          options: {
            url: "/api/roles/dropdown",
            multiple: false,
            liveOptions: false,
            checkbox: false
          }
        },
        size: 2
      },
      {
        name: "Active",
        description: "Active Status",
        filter: {
          enabled: true,
          required: true,
          comparison: "==",
          type: "select",
          value: statusValues,
          defaultValue: "true"
        },
        size: 2
      }
    ]
  };

  React.useEffect(() => {
    api
      .get("/api/login/authorized")
      .then((r) => {
        console.log("user");
        console.log(userStore.user_profile);
        homeDispatch({
          type: "UPDATE_CURRENT_LOCATION",
          data: "Users"
        });
      })
      .catch((error) => errorManagement.formErrors(error, homeDispatch));
  }, [homeDispatch]);

  const handleClickEdit = (event, entry) => {
    setCurrentEntry(entry);
    console.log(entry);
    setOpenEdit(true);
  };

  const handleClickConfirmSendReset = (event, entry) => {
    setResetParams({ id: entry.id });
    setOpenReset(true);
  };
  const cancelSendReset = () => {
    setResetParams(null);
  };

  const sendResetEmail = (params) => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Sending password reset email", loading: true }
    });
    api
      .post(`/api/users/${params.id}/passwordReset`)
      .then((response) => {
        homeDispatch({
          type: "NOTIFICATION",
          data: { message: response.data.message, type: response.data.status }
        });
      })
      .catch((error) => {
        errorManagement.formErrors(error, homeDispatch);
      });
  };

  const refreshItems = () => {
    setRefresh(refresh + 1);
  };

  function handleClickCreateServiceAccount() {
    setOpenCreateService(true);
  }

  return (
    <React.Fragment>
      <Grid container spacing={2} justifyContent={"space-between"}>
        {allowActions && (
          <React.Fragment>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleClickCreate}
                startIcon={<AddBoxIcon />}
              >
                New User
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleClickCreateServiceAccount}
                startIcon={<AddBoxIcon />}
              >
                New Service Account User
              </Button>
            </Grid>
          </React.Fragment>
        )}
        <Grid item xs={12}>
          <MyDataGrid
            options={tableOptions}
            url={"/api/users"}
            refresh={refresh}
            label={"Users"}
            renderItem={(item, index) => (
              <Entry
                key={index}
                entry={item}
                allowActions={allowActions}
                isAdmin={isAdmin}
                onEdit={handleClickEdit}
                onSendReset={handleClickConfirmSendReset}
              />
            )}
          />
        </Grid>
      </Grid>
      {allowActions && (
        <React.Fragment>
          <Edit
            open={openEdit}
            setOpen={setOpenEdit}
            entry={currentEntry}
            onEdit={refreshItems}
          />
          <Create
            open={openCreate}
            setOpen={setOpenCreate}
            onCreate={refreshItems}
          />
          <ConfirmDialog
            open={openReset}
            setOpen={setOpenReset}
            title={"Send reset email"}
            message={
              "Are you sure that you want to send the user an email with instructions to reset their own password?"
            }
            onCloseSuccess={sendResetEmail}
            successParams={resetParams}
            onClose={cancelSendReset}
          />
          <CreateServiceAccount
            open={openCreateService}
            setOpen={setOpenCreateService}
            onCreate={refreshItems}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
